// usePagination.js
import { useEffect, useState } from "react";

export const PAGE_SIZE_OPTIONS = [8, 15, 20, 25];

export const getDefaultPageSize = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(max-width: 640px)").matches
    ? 8
    : 15;

export function usePagination(totalCount) {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15); // will be set on mount

  // set correct default after mount (avoids SSR/hydration mismatch)
  useEffect(() => {
    let saved = null;
    try {
      saved = Number(localStorage.getItem("table.pageSize"));
    } catch {
      saved = null;
    }
    setPageSize(Number.isFinite(saved) ? saved : getDefaultPageSize());
  }, []);

  const pageCount = Math.max(1, Math.ceil((totalCount || 0) / pageSize));

  // clamp page if data or size changes
  useEffect(() => {
    setPage((p) => Math.min(p, pageCount - 1));
  }, [pageCount]);

  const start = page * pageSize;
  const end = start + pageSize;
  const canPrev = page > 0;
  const canNext = page < pageCount - 1;

  const setPageSizeAndPersist = (n) => {
    setPage(0);
    setPageSize(n);
    try {
      console.log(String(n))
      localStorage.setItem("table.pageSize", String(n));
    } catch {}
  };

  return {
    page,
    setPage,
    pageSize,
    setPageSize: setPageSizeAndPersist,
    start,
    end,
    canPrev,
    canNext,
    pageCount,
  };
}
